<template>
    <svg
        width="230"
        height="253"
        viewBox="0 0 230 253"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_d_595_1477)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M148.026 32.7969C140.692 31.1188 128.638 30 115.022 30C101.407 30 89.3412 31.1188 82.0189 32.7969C74.8433 34.3108 68.2619 37.8762 63.0743 43.0598C57.8867 48.2434 54.3163 54.8221 52.7969 61.9966C51.1188 69.33 50 81.3847 50 95C50 108.615 51.1188 120.681 52.7969 128.003C54.3147 135.175 57.8818 141.752 63.0651 146.935C68.2484 152.118 74.8251 155.685 81.9966 157.203C89.33 158.881 101.385 160 115 160C128.615 160 140.681 158.881 148.003 157.203C155.175 155.685 161.752 152.118 166.935 146.935C172.118 141.752 175.685 135.175 177.203 128.003C178.881 120.67 180 108.615 180 95C180 81.3847 178.881 69.3189 177.203 61.9966C175.687 54.828 172.123 48.2534 166.944 43.0704C161.765 37.8873 155.193 34.3185 148.026 32.7969Z"
                fill="white"
            />
        </g>
        <g filter="url(#filter1_dd_595_1477)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M145.485 37.5818C138.716 36.0327 127.589 35 115.021 35C102.453 35 91.315 36.0327 84.5559 37.5818C77.9323 38.9792 71.8571 42.2703 67.0686 47.0552C62.28 51.8401 58.9843 57.9127 57.5818 64.5353C56.0327 71.3046 55 82.432 55 95C55 107.568 56.0327 118.706 57.5818 125.465C58.9828 132.085 62.2755 138.155 67.0601 142.94C71.8447 147.725 77.9154 151.017 84.5353 152.418C91.3046 153.967 102.432 155 115 155C127.568 155 138.706 153.967 145.465 152.418C152.085 151.017 158.155 147.725 162.94 142.94C167.725 138.155 171.017 132.085 172.418 125.465C173.967 118.695 175 107.568 175 95C175 82.432 173.967 71.2943 172.418 64.5353C171.019 57.9182 167.729 51.8493 162.948 47.065C158.168 42.2806 152.101 38.9863 145.485 37.5818Z"
                fill="white"
            />
        </g>
        <g filter="url(#filter2_d_595_1477)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M145.485 37.5818C138.716 36.0327 127.589 35 115.021 35C102.453 35 91.315 36.0327 84.5559 37.5818C77.9323 38.9792 71.8571 42.2703 67.0686 47.0552C62.28 51.8401 58.9843 57.9127 57.5818 64.5353C56.0327 71.3046 55 82.432 55 95C55 107.568 56.0327 118.706 57.5818 125.465C58.9828 132.085 62.2755 138.155 67.0601 142.94C71.8447 147.725 77.9154 151.017 84.5353 152.418C91.3046 153.967 102.432 155 115 155C127.568 155 138.706 153.967 145.465 152.418C152.085 151.017 158.155 147.725 162.94 142.94C167.725 138.155 171.017 132.085 172.418 125.465C173.967 118.695 175 107.568 175 95C175 82.432 173.967 71.2943 172.418 64.5353C171.019 57.9182 167.729 51.8493 162.948 47.065C158.168 42.2806 152.101 38.9863 145.485 37.5818Z"
                fill="white"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_595_1477"
                x="0"
                y="0"
                width="230"
                height="230"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="20" />
                <feGaussianBlur stdDeviation="25" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 0.0737305 0 0 0 0 0.476874 0 0 0 0.3 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_595_1477"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_595_1477"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_dd_595_1477"
                x="12"
                y="33"
                width="211.2"
                height="219.2"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="-3" dy="38" />
                <feGaussianBlur stdDeviation="20" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 0.330469 0 0 0 0 0.464375 0 0 0 1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_595_1477"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="17" dy="66" />
                <feGaussianBlur stdDeviation="15.6" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 0.556863 0 0 0 0 0.282353 0 0 0 1 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_dropShadow_595_1477"
                    result="effect2_dropShadow_595_1477"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow_595_1477"
                    result="shape"
                />
            </filter>
            <filter
                id="filter2_d_595_1477"
                x="43"
                y="27"
                width="144"
                height="144"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="6" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.811765 0 0 0 0 0.00784314 0 0 0 0 0.513726 0 0 0 0.3 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_595_1477"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_595_1477"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
</template>

<script setup lang="ts"></script>
